// extracted by mini-css-extract-plugin
export var aboutSection = "about-module--about-section--a11aa";
export var bottomFade = "about-module--bottom-fade--800ac";
export var fade = "about-module--fade--c7421";
export var headingBox = "about-module--heading-box--4ad75";
export var myImage = "about-module--my-image--b92a6";